import React from 'react';
import { Box } from '@mui/material';
import { vars } from '../../../Theme';
import { buildNumber, environmentVar } from '../../../Constants';

/** Example value: DEV-20240716.XX */
export default () => {
    if (!environmentVar) {
        return <></>;
    }

    const label = `${environmentVar}` + (buildNumber ? `-${buildNumber}` : ' local');

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 0,
                right: 0,
                transform: 'rotate(-45deg)',
                transformOrigin: 'left top',
                opacity: 0.5,
                color: vars.red,
                backgroundColor: vars.neonYellow,
                padding: '5px 10px',
                borderRadius: '4px',
                zIndex: 5,
            }}
        >
            {label}
        </Box>
    );
};
